// extracted by mini-css-extract-plugin
var _1 = "AuthView-module__container__sKVxf";
var _2 = "AuthView-module__form_container__O45jp";
var _3 = "AuthView-module__left_container__COb_C";
var _4 = "AuthView-module__right_container__rCPXu";
export { _1 as "container", _2 as "form_container", _3 as "left_container", _4 as "right_container" }
